import { ChevronLeft } from "@cmp-src/icons/TacticIcons/ChevronLeft";
import { ChevronRight } from "@cmp-src/icons/TacticIcons/ChevronRight";
import { ButtonProps } from "@cmp-src/primitives/button";
import { ButtonGroup } from "../ButtonGroup/ButtonGroup";
import { ButtonInGroup } from "../ButtonGroup/ButtonInGroup";
import { cn } from "@gettactic/helpers";

export interface ArrowsGroupProps {
  /** Props for the "next" button, typically `onClick`. Its `aria-label` defaults to "Next". */
  rightProps?: ButtonProps;
  /** Props for the "previous" button, typically `onClick`. Its `aria-label` defaults to "Previous". */
  leftProps?: ButtonProps;
  className?: string;
  /** @default true */
  showLeft?: boolean;
  /** @default true */
  showRight?: boolean;
}

/**
 * Joined previous / next arrow buttons, used to step through weeks and days next to a
 * date picker. Hide one side with `showLeft` / `showRight`: the remaining arrow stays flat on
 * the hidden side, so it can sit flush against the date input. With both hidden it renders nothing.
 */
export const ArrowsGroup = ({
  rightProps,
  leftProps,
  className,
  showLeft = true,
  showRight = true
}: ArrowsGroupProps) => {
  if (!showLeft && !showRight) return null;
  return (
    <ButtonGroup className={cn(className)}>
      {showLeft && (
        <ButtonInGroup
          aria-label="Previous"
          {...leftProps}
          className={cn("w-[38px] p-0 radius-right-none", leftProps?.className)}
          isAlone={!showRight}
        >
          <ChevronLeft className="h-4 w-4" aria-hidden="true" />
        </ButtonInGroup>
      )}
      {showRight && (
        <ButtonInGroup
          aria-label="Next"
          {...rightProps}
          className={cn("w-[38px] p-0 radius-left-none", rightProps?.className)}
        >
          <ChevronRight className="h-4 w-4" aria-hidden="true" />
        </ButtonInGroup>
      )}
    </ButtonGroup>
  );
};
